import { useState } from "react";
import SignInForm from "./components/SignInForm";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import AuthLayout from "./layout/AuthLayout";

function AuthenticationPage() {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  return (
    <AuthLayout>
      {!showForgotPassword ? (
        <SignInForm onForgotPasswordClick={() => setShowForgotPassword(true)} />
      ) : (
        <ForgotPasswordForm onGoBack={() => setShowForgotPassword(false)} />
      )}
    </AuthLayout>
  );
}

export default AuthenticationPage;
